import { Factory } from '../../services/Factory';




export interface IBatchCountScope extends angular.IScope {
  value: any;
}

export interface IBatchCountAttributes extends angular.IAttributes {
  batchId: string;
  reviewState: string;
}

export class BatchCount implements angular.IDirective {
  public restrict: string = 'A';
  public link: (scope: IBatchCountScope, element: angular.IAugmentedJQuery, attrs: IBatchCountAttributes) => void;
  public template: string;

  public scope = {};

  constructor() {

    this.template = "<span>{{ value }}</span>";

    this.link = (scope: IBatchCountScope, element: angular.IAugmentedJQuery, attrs: IBatchCountAttributes) => {

      if (attrs.reviewState == "reviewed") {
        scope.$on('reviewmetrics.batch.reviewed', (evt, data) => {
          if (attrs.batchId == data["batchId"]) {
            scope.value = data["count"];
            scope.$applyAsync();
          }
        });
      }

      if (attrs.reviewState == "notReviewed") {
        scope.$on('reviewmetrics.batch.notReviewed', (evt, data) => {
          if (attrs.batchId == data["batchId"]) {
            scope.value = data["count"];
            scope.$applyAsync();
          }
        });
      }
    }
  }

}

frontendApp.directive("iioBatchCount", [Factory.Create(BatchCount)]);
